// Server-sent events (GET /api/events). Every message is `data: <StudioEvent json>`; the stream is personal:
// own jobs arrive in full as `job`, other people's unfinished jobs as redacted `queue` entries.
import { z } from "zod";
import { Asset, GpuState, Job, RedactedJob } from "./core";
import { GpuSample, RunnerInfo } from "./fleet";

export const StudioEvent = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("hello"),
    /** The viewer's unfinished jobs plus their 50 most recent finished ones. */
    jobs: z.array(Job),
    gpu: GpuState,
    /** Everyone's unfinished jobs in queue order (own ones with jobId). */
    queue: z.array(RedactedJob),
    runners: z.array(RunnerInfo),
  }),
  /** One of the viewer's own jobs changed. */
  z.object({ type: z.literal("job"), job: Job }),
  /** Someone else's job changed (also sent once when it finishes, so it can leave the queue). */
  z.object({ type: z.literal("queue"), job: RedactedJob }),
  z.object({ type: z.literal("gpu"), gpu: GpuState }),
  /** A new asset of the viewer's. */
  z.object({ type: z.literal("asset"), asset: Asset }),
  /** Runners or slots changed (online, loaded model, busy); throttled to one per second. */
  z.object({ type: z.literal("runners"), runners: z.array(RunnerInfo) }),
  /** Latest GPU telemetry of every runner; at most one every 5 s. */
  z.object({ type: z.literal("telemetry"), at: z.string(), gpus: z.array(GpuSample) }),
]);
export type StudioEvent = z.infer<typeof StudioEvent>;
